import { render, staticRenderFns } from "./CommunityHomePopupForm.vue?vue&type=template&id=b39ffc44&scoped=true"
import script from "./CommunityHomePopupForm.vue?vue&type=script&lang=js"
export * from "./CommunityHomePopupForm.vue?vue&type=script&lang=js"
import style0 from "./CommunityHomePopupForm.vue?vue&type=style&index=0&id=b39ffc44&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39ffc44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b39ffc44')) {
      api.createRecord('b39ffc44', component.options)
    } else {
      api.reload('b39ffc44', component.options)
    }
    module.hot.accept("./CommunityHomePopupForm.vue?vue&type=template&id=b39ffc44&scoped=true", function () {
      api.rerender('b39ffc44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/popupWindows/components/CommunityHomePopupForm.vue"
export default component.exports